<script lang="ts">
import { computed, defineComponent, h, ref, unref } from 'vue';

import { omit } from '@components/utils';

import {
  makeDisabledProps,
  makeGroupItemProps,
  makeIconProps,
  makeLoadingProps,
  makeReadonlyProps,
  makeSizeProps,
  makeTextProps,
  useRender
} from '../../composable';
import { CdsButton } from '../CdsButton';

import { CdsTabsV2Symbol } from './shared';

export const componentName = 'CdsTabV2';
export default defineComponent({
  name: componentName,
  props: {
    ...makeGroupItemProps({
      selectedClass: 'cds-tab-v2--selected'
    }),
    ...makeTextProps(),
    ...makeIconProps(),
    ...makeSizeProps(),
    ...makeDisabledProps(),
    ...makeReadonlyProps(),
    ...makeLoadingProps()
  },
  emits: {
    'group:selected': (value: { value: boolean }) => true
  },
  setup(props, { slots, attrs }) {
    const rootEl = ref<typeof CdsButton>();
    const isSelected = computed(() => unref(rootEl)?.groupItem?.isSelected.value ?? false);

    useRender(() => {
      const btnProps = omit(props, []);

      return h(
        CdsButton,
        {
          ref: rootEl,
          symbol: CdsTabsV2Symbol,
          active: false,
          appearance: 'transparent',
          role: 'tab',
          class: 'cds-tab-v2',
          tabindex: unref(isSelected) ? 0 : -1,
          ariaSelected: String(unref(isSelected)),
          ...btnProps,
          ...attrs
        },
        {
          default: () => [slots.default?.() ?? props.text],
          ...(slots.prepend ? { prepend: () => slots.prepend?.() } : {}),
          ...(slots.append ? { append: () => slots.append?.() } : {})
        }
      );
    });

    return {};
  }
});
</script>
